
<template lang="pug">
QContextMenuMod2.context-menu2(@beforeShow="onBeforeShow")
  q-list(
    highlight
    v-close-overlay
    @contextmenu.native.prevent
  )
    q-item(
      v-for="option of options"
      :key="option.label"
      @click.native="onClick($event, option)"
    )
      q-item-side.context-menu2-item-side(
        v-if="hasCheck"
        :icon="option.check ? 'check' : ''"
      )
      q-item-main
        q-item-tile {{option.label}}
</template>

<script>
import QContextMenuMod2 from './QContextMenuMod2'

export default {
  components: {QContextMenuMod2},

  data() {
    return {
      options: [],
    }
  },

  computed: {
    hasCheck() {
      return this.options.some(option => option.check != null)
    },
  },

  methods: {
    onBeforeShow(evt, show) {
      this.$emit('beforeShow', evt, options => {
        this.options = options
        show()
      })
    },

    onClick(evt, option) {
      if(option.onClick != null) {
        option.onClick(evt)
      }
    },
  },
}
</script>

<style lang="sass">
.context-menu2
  user-select: none

.context-menu2-item-side
  min-width: 1.5rem
  width: 1.5rem

.context-menu2-item-side > .q-icon
  font-size: 1.5rem !important

</style>
